<template>
  <div>
    <v-row no-gutters v-for="(item, key) in items" :key="key">
      <v-col cols="2" class="mr-4 pt-5">
        <p v-if="key === 0" class="font-weight-medium">{{ label }}</p>
      </v-col>

      <v-col cols="2" class="mr-2 pt-2 mr-2">
        <v-autocomplete
            v-if="key === 0"
            dense
            :items="openOptions"
            v-on:change="val => change24hours(val)"
            v-model="open"
            outlined
        ></v-autocomplete>
      </v-col>

      <v-col v-if="open === 'Aberto'" cols="2" class="ml-2 mr-2 pt-2">
        <time-picker
            label="Abre à(s)"
            v-on:change="val => changeOpenTime(val, key)"
            v-bind:value="item.open_time"
        />
      </v-col>

      <v-col cols="2" v-if="open === 'Aberto'"  class="ml-2 mr-2 pt-2">
        <time-picker
            label="Fecha à(s)"
            v-on:change="val => changeCloseTime(val, key)"
            v-bind:value="item.close_time"
        />
      </v-col>

      <div class="pt-3">
        <v-btn
            v-if="open === 'Aberto' && items.length > 1"
            color="primary"
            icon
            @click="removeOne($event, key)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-col
          v-if="open === 'Aberto' && items.length === key + 1"
          cols="1"
          class="action-cols ml-2 pt-4"
      >
        <v-btn
            v-if="items.length < limit"
            small
            color="primary"
            text
            @click="addOne"
        >
          {{ addText }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TimePicker from '@/components/TimePicker'

const OPEN = 'Aberto'
const CLOSED = 'Fechado'
const ALWAYS_OPEN = '24 Horas'

export default {
  name: "LocationMoreScheduleItem",
  props: {
    limit: {
      type: Number,
      required: true
    },
    value: Array,
    addText: {
      type: String,
      default: 'Adicionar'
    },
    label: {
      type: String,
      required: true
    },
    keyName: String
  },
  components: {
    TimePicker
  },
  data: () => ({
    itemSelected: '',
    open: OPEN,
    items: [],
    openOptions: [OPEN, CLOSED, ALWAYS_OPEN]
  }),
  methods: {
    changeOpenTime(time, index) {
      this.items[index].open_time = time
      this.items[index].open = !!(this.items[index].open_time && this.items[index].close_time)
      this.change()
    },
    changeCloseTime(time, index) {
      this.items[index].close_time = time
      this.items[index].open = !!(this.items[index].open_time && this.items[index].close_time)
      this.change()
    },
    change() {
      let data = {
        key: this.keyName,
        data: this.items
      }
      this.$emit('change', data)
    },
    addOne() {
      if (this.items.length < this.limit) {
        this.items.push({
          open_time: '',
          close_time: '',
          open: false
        })
      }
    },
    removeOne(event, index) {
      if (this.items.length > 0) {
        this.items.splice(index, 1)
      }
    },
    change24hours(value) {
      if (value === ALWAYS_OPEN) {
        this.items = [{
          open_time: '',
          close_time: '',
          open: false,
          is_24_hours: true
        }]
      } else if (value === CLOSED) {
        this.items = [{
          open_time: '',
          close_time: '',
          open: false,
          is_24_hours: false
        }]
      } else if (value === OPEN) {
        this.items = [{
          open_time: '',
          close_time: '',
          open: true,
          is_24_hours: false
        }]
      }
      this.$emit('change', this.items)
    }
  },
  mounted() {
    if (this.value) {
      this.items = JSON.parse(JSON.stringify(this.value)) // Cria uma cópia do objeto
      if (Array.isArray(this.items) && this.items[0].is_24_hours) {
        this.open = ALWAYS_OPEN
      }
    } else {
      this.items = [{
        open_time: '',
        close_time: '',
        is_24_hours: false,
        open: false
      }]
      this.open = CLOSED
    }
  },
  watch: {
    itemSelected(val) {
      this.items.map((item, index) => {
        item.selected = index === val
        return item
      })
      this.change()
    },
    items() {
      this.change()
    },
    value(value) {
      this.items = value
    }
  }
}
</script>

<style scoped>
.action-cols {
  min-width: 56px
}
</style>